export const launchHandler = {
    pathPattern: '/brands/:brandId/launch',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/launch` }),
    meta: {
        title: 'Launch',
        description: 'Opens the brand launch flow in the dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: { params: { brandId: 'BXqExampleBrandId' } },
    },
};
//# sourceMappingURL=launch.js.map